import { render, staticRenderFns } from "./CurrentMonthOffers.vue?vue&type=template&id=49b1f850&scoped=true"
import script from "./CurrentMonthOffers.vue?vue&type=script&lang=ts"
export * from "./CurrentMonthOffers.vue?vue&type=script&lang=ts"
import style0 from "./CurrentMonthOffers.vue?vue&type=style&index=0&id=49b1f850&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b1f850",
  null
  
)

export default component.exports